import { render, staticRenderFns } from "./HighlightItem.vue?vue&type=template&id=bebdabf8&scoped=true&"
import script from "./HighlightItem.vue?vue&type=script&lang=js&"
export * from "./HighlightItem.vue?vue&type=script&lang=js&"
import style0 from "./HighlightItem.vue?vue&type=style&index=0&id=bebdabf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebdabf8",
  null
  
)

export default component.exports